import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { installGuards } from './router/guards'
import { installStaleChunkReload } from './lib/stale-chunk'
import { i18n } from './i18n'
import { useAuthStore } from './stores/auth'
import { useLocaleStore } from './stores/locale'
import { useThemeStore } from './stores/theme'

installStaleChunkReload()

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)

installGuards(router)

async function bootstrap(): Promise<void> {
  useLocaleStore().init()
  useThemeStore().init()
  await useAuthStore().init()
  await router.isReady()
  app.mount('#app')
}

void bootstrap().catch((error: unknown) => {
  console.error('Failed to bootstrap the app', error)
  app.mount('#app')
})
